import { Skeleton, LoadingOverlay } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

const OverviewLoader = ({ isLoading }) => {
  const isMobile = useMediaQuery("(max-width: 992px)");

  if (isLoading) {
    if (isMobile) {
      return (
        <div className="position-relative mt-3 w-full">
          <LoadingOverlay
            zIndex={10}
            visible={true}
            transitionDuration={500}
            overlayOpacity={0.3}
            loaderProps={{ size: "lg", color: "teal", variant: "oval" }}
          />
          {Array.from(Array(1).keys()).map((_, index) => (
            <Skeleton height={768} mb={15} key={index} width="100%" />
          ))}
        </div>
      );
    }

    return (
      <div style={{ display: "relative" }}>
        <LoadingOverlay visible={isLoading} transitionDuration={500} />
      </div>
    );
  }
  return null;
};

export default OverviewLoader;
